const os = navigator?.userAgentData?.platform || navigator?.platform || 'unknown';
const browser = navigator.userAgent;
const url = window.location.href;

export { os, browser, url };
